import {Box, Button} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import {OrderStatusTag} from "./OrderStatusTag";
import {OrderItem} from "./OrderItem";
import {getCurrencySymbol, isTimeToday} from "../../../../../_helpers";
import {formatDateCreated} from "../ProactiveMetricsDetailUtil";

export const OrderContainer = ({toggleOrderDetails, selectedOrder, order}) => {
    const currency = getCurrencySymbol(order?.orderValue?.currency)

    return(
        <Box sx={{border: '1px solid #CED2D0', borderRadius: '6px'}}>
            <Button sx={styles.accordionButton} onClick={() => toggleOrderDetails(order.id)} disableRipple>
                <Box as={'span'} display={"block"}>
                    <Box as={'a'}
                         href={order?.link}
                         rel="nofollow noreferrer noopener"
                         target="_blank"
                         sx={styles.orderLink}
                         onClick={(e) => {
                        e.stopPropagation();
                    }}>
                        {order?.orderNumber || "-"}
                    </Box>
                    <Box as={'span'} sx={{...styles.buttonDetail, fontSize: "15px", color: "#000000",}}>
                        {currency}{order?.orderValue?.amount}
                    </Box>
                    <Box as={'span'} sx={{...styles.buttonDetail, color: "#858585", marginTop: "5px"}}>
                        {isTimeToday(order.createdAt)
                            ? formatDateCreated(order.createdAt, "HH:mm a")
                            : formatDateCreated(order.createdAt, "MM/DD/YYYY")}
                    </Box>
                </Box>

                <Box as={'span'}>
                    { selectedOrder === order?.id ?
                        <ExpandLessIcon/> : <ExpandMoreIcon />
                    }
                </Box>
            </Button>

            {selectedOrder === order?.id &&
                <div>
                    <Box sx={{padding: '10px 10px 0px'}}>
                        { order?.discountCodes?.length > 0 &&
                            <Box sx={styles.discount}>
                                Discount used -
                                {order.discountCodes.map((item, index) => (
                                    <Box key={index} sx={styles.discountTag}>
                                        {item}
                                    </Box>
                                ))}
                            </Box>
                        }

                        <Box sx={{width: 'fit-content', marginTop: '6px'}}>
                            <OrderStatusTag status={order.status} />
                        </Box>
                    </Box>

                    <Box sx={{padding: '0px 10px'}}>
                        {order?.items?.map((item, index) => {
                            return(
                             <OrderItem data={item} key={index} />
                            )
                        })}
                    </Box>
                </div>
            }
        </Box>
    )
}

const styles = {
    accordionButton: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "10px",
        backgroundColor: '#FFFFFF',
        padding: "10px",
        borderRadius: "6px",
        textAlign: "left",
        width: "100%",
        color: "#000000"
    },
    buttonDetail: {
        fontFamily: "FustatSemiBold",
        color: "#595959",
        fontSize: "12px",
        margin: "0px",
        display: "block",
        textTransform: "capitalize",
        lineHeight: "120%",
    },
    discount: {
        fontSize: "14px",
        fontFamily: "FustatRegular",
        display: "flex",
        alignItems: "center",
        gap: "4px",
        flexWrap: "wrap",
        color: "#595959"
    },
    discountTag: {
        fontFamily: "FustatSemiBold",
        fontSize: "12px",
    },
    orderLink: {
        fontFamily: "FustatRegular",
        fontSize: "14px",
        margin: "0px",
        display: "block",
        textDecoration: "none",
        color: "#000000",
        "&:hover, &:visited, &:active": {
            textDecoration: "none",
            color: "#000000"
        },
    }
}